export default "__VITE_ASSET__DWGYSqob__"